import { useQuery } from 'react-query';
import { subscriptionService } from 'services';
import { ServerStateKeysEnum } from 'reactQuery/constants';

export const useSubscriptionDetail = (id: number) => {
  return useQuery(
    [ServerStateKeysEnum.subscriptionDetail, id],
    () => {
      return subscriptionService.subscriptionDetail(id);
    },
    { staleTime: 5 * 60 * 1000 } // 5 minutes
  );
};
